import { Pipe, PipeTransform } from '@angular/core';
import { Quotation } from '../models/quotation.model';
@Pipe({
    name: 'quotationDisplay'
})


export class QuotationDisplay implements PipeTransform {

    MAX_CODE_LENGTH = 12;

    transform(quotation?: Quotation): any {
        if (quotation) {
            const truncatedCode = quotation.code.slice(0, this.MAX_CODE_LENGTH);
            return `${quotation.name} - ${quotation.salesPartnerName} (${truncatedCode}-${quotation.version})`;
        }
        return quotation;
    }
}
